import { useMemo } from "react";

import { useConfig } from "@stadium/hooks/lib/use-config";
import { selectRestrictionTaxons } from "@stadium/redux-utils/selectors/configSelector";

const useFetchTaxon = () => {
  const items = useConfig(selectRestrictionTaxons);

  const restrictions = useMemo(() => {
    return items.map((item) => ({
      ...item,
      externalId: item.id,
      icon: item.imageUrl?.mini,
    }));
  }, [items]);

  return {
    restrictions,
  };
};

export default useFetchTaxon;
